import { useEffect, useRef } from "react";
import { BOOKING_15MIN_URL } from "@/hooks/use-cal";

const GHL_EMBED_SCRIPT = "https://link.msgsndr.com/js/form_embed.js";
const CALENDAR_IFRAME_ID = "plan-de-match-calendar-iframe";

const getMessageHeight = (data: unknown): number | null => {
  if (typeof data === "string") {
    if (data.startsWith("[iFrameSizer]")) {
      const payload = data.slice("[iFrameSizer]".length).split(":");
      const height = Number(payload[1]);
      return Number.isFinite(height) ? height : null;
    }

    try {
      return getMessageHeight(JSON.parse(data));
    } catch {
      return null;
    }
  }

  if (typeof data !== "object" || data === null) return null;

  const message = data as Record<string, unknown>;
  const candidates = [message.height, message.frameHeight, message.iframeHeight];
  for (const candidate of candidates) {
    const height = Number(candidate);
    if (Number.isFinite(height)) return height;
  }

  return message.payload ? getMessageHeight(message.payload) : null;
};

const PlanDeMatchCalendar = () => {
  const iframeRef = useRef<HTMLIFrameElement>(null);

  useEffect(() => {
    const iframe = iframeRef.current;
    if (!iframe) return;

    iframe.style.height = window.matchMedia("(min-width: 768px)").matches
      ? "620px"
      : "1150px";

    const handleMessage = (event: MessageEvent) => {
      if (event.source !== iframe.contentWindow) return;

      try {
        const hostname = new URL(event.origin).hostname;
        const trustedOrigin =
          hostname === "msgsndr.com" ||
          hostname.endsWith(".msgsndr.com") ||
          hostname === "leadconnectorhq.com" ||
          hostname.endsWith(".leadconnectorhq.com");
        if (!trustedOrigin) return;
      } catch {
        return;
      }

      const height = getMessageHeight(event.data);
      if (height === null || height <= 0) return;
      iframe.style.height = `${Math.ceil(height)}px`;
    };

    window.addEventListener("message", handleMessage);

    const existingScript = document.querySelector<HTMLScriptElement>(
      `script[src="${GHL_EMBED_SCRIPT}"]`,
    );

    if (existingScript) {
      const resize = (
        window as Window & {
          iFrameResize?: (options: object, iframe: HTMLIFrameElement) => void;
        }
      ).iFrameResize;
      resize?.({}, iframe);
    } else {
      const script = document.createElement("script");
      script.src = GHL_EMBED_SCRIPT;
      script.async = true;
      document.body.appendChild(script);
    }

    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, []);

  return (
    <section
      id="calendrier"
      className="py-12 md:py-20"
      style={{ background: "#080a09" }}
    >
      <div
        className="mx-auto w-full px-6"
        style={{ maxWidth: 900, display: "block", lineHeight: 0, border: "none" }}
      >
        <iframe
          ref={iframeRef}
          id={CALENDAR_IFRAME_ID}
          src={BOOKING_15MIN_URL}
          title="Réserver un appel de 15 minutes"
          scrolling="no"
          loading="lazy"
          className="block w-full"
          style={{
            width: "100%",
            border: "none",
            borderRadius: "16px",
            background: "#080a09",
          }}
        />
      </div>
    </section>
  );
};

export default PlanDeMatchCalendar;
